// ── Browser Inspect Protection ───────────────────────────────────────────────
// Set to true to block right-click, F12, and DevTools shortcuts in the browser
export const DISABLE_INSPECT = false;

// ── Auth ──────────────────────────────────────────────────────────────────────
export const ACCESS_KEY = "planetbeyond1122";

// ── HeyGen Live Avatar ───────────────────────────────────────────────────────
export const API_KEY = "f5fd0f62-df0e-11f0-a99e-066a7fa2e369";
export const API_URL = "https://api.liveavatar.com";
export const AVATAR_ID = "669cbe3b-bab0-4729-84fa-67fb65f06e36";
export const SESSION_ROLLOVER_MS = 15 * 60_000;
export const SESSION_PREWARM_LEAD_MS = 20_000;

// FULL MODE
export const VOICE_ID = "62bbb4b2-bb26-4727-bc87-cfb2bd4e0cc8";
export const CONTEXT_ID = "16796ec6-d6b7-4886-83a7-b586cfffd00a";
export const LANGUAGE = "hi";
